
<div>
    <nz-spin [nzSpinning]="isLoading" nzTip="loading..." >
        <form nz-form [formGroup]="helpForm" [nzLayout]="'vertical'" >
            <div class="row">
                <div class="col-md-12 col-sm-12 col-xs-12">
                    <div class="text-success" *ngIf="showSuccessMessage" style="padding-bottom: 20px; font: 300;">
                        Your Request Sent Successfully
                    </div>
                    <nz-form-item>
                        <nz-form-label nzFor="yourEmail" nzRequired>Your Email</nz-form-label>
                        <nz-form-control readonly>
                            <input nz-input type="text" formControlName="yourEmail" (input)="formEdited = true"
                                inputRestriction restrictionType="noSpecialChars" />
                        </nz-form-control>
                    </nz-form-item>
                </div>
            </div>
            
            <div class="row">
                <div class="col-md-12 col-sm-12 col-xs-12">
                    <nz-form-item>
                        <nz-form-label nzFor="enquiryType" nzRequired>Enquiry Type</nz-form-label>
                        <nz-form-control>
                            <nz-select name="enquiryType" id="enquiryType" formControlName="enquiryType" nzSize="small"
                                nzPlaceHolder="Select--" inputRestriction>
                                <nz-option *ngFor="let type of categoryOption" [nzValue]="type" [nzLabel]="type"></nz-option>
                            </nz-select>
                            <ng-container *ngIf="helpForm.get('enquiryType').hasError('required') && helpForm.get('enquiryType').touched">
                                <div class="text-danger pt-1">Please select an Enquiry Type!</div>
                            </ng-container>
                        </nz-form-control>
                    </nz-form-item>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 col-sm-12 col-xs-12">
                    <nz-form-item>
                        <nz-form-label nzFor="description" nzRequired>Description</nz-form-label>
                        <nz-form-control>
                            <textarea nz-input name="description" minlength="3" maxlength="1000" type="text" id="description" (input)="formEdited = true"
                            formControlName="description" nzSize="large" inputRestriction restrictionType="noSpecialChars" style="height: 130px;"></textarea>
                            <ng-container *ngIf="helpForm.get('description').hasError('required') && helpForm.get('description').touched">
                                <div class="text-danger pt-1">Please Enter Description!</div>
                            </ng-container>
                        </nz-form-control>
                    </nz-form-item>
                </div>
            </div>
            
            <div class="text-right">
                <nz-form-item>
                    <nz-form-control class="text-center" style="padding-left: 304px;">
                        <button nz-button nzType="primary" [disabled]="!helpForm.valid || !formEdited" (click)="successSubmit()">Send</button>
                        &nbsp;
                        <button nz-button (click)="closeModal()">Cancel</button>
                    </nz-form-control>
                </nz-form-item>
            </div>
            
</form>
</nz-spin>
</div>